// usePollingLivestreamDetailData.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import fetchLivestreamDetail from '../action/fetchLivestreamDetail.js';

/**
 * Hook to poll livestream detail data.
 * @param {object} options - hook options.
 * @param {string} [options.streamId = ''] - stream id.
 * @param {number} [options.intervalSeconds = 3] - interval seconds.
 * @param {boolean} [options.canFetchData = false] - whether to fetch data.
 */
const usePollingLivestreamDetailData = ({
  streamId = '',
  intervalSeconds = 3,
  canFetchData = false,
} = {}) => {
  const dispatch = useDispatch();

  // fetch livestream detail interval.
  useEffect(() => {
    let timer;

    if (canFetchData) {
      dispatch(fetchLivestreamDetail({ streamId }));
      timer = setInterval(() => {
        dispatch(fetchLivestreamDetail({ streamId }));
      }, intervalSeconds * 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [canFetchData, dispatch, intervalSeconds, streamId]);
};

export default usePollingLivestreamDetailData;
